import { FC, useMemo } from 'react';
import { Values } from 'atoms/RangeSlider/types';
import { RangeSliderWithCurrency } from 'molecules/RangeSliderWithCurrency';
import {
  Facets,
  FactFinderFacetElementPrice,
  IFilter,
} from 'commerce/factFinder/types';
import { FilterItem } from '../FilterItem';
import { useFilters } from '../hooks';
import { IPriceInfo } from '../types';

const getInitPrices = (filters: IFilter[], min = 0, max = 1) => {
  const prices = filters.find((a) => a.type === Facets.PRICE);

  if (!prices) {
    return [min, max];
  }

  return prices.value as number[];
};

export const RangePrices: FC = () => {
  const { facets, filters, addSingleFilter } = useFilters();

  const priceInfo = useMemo<IPriceInfo | null>(() => {
    const data = facets.find(
      ({ associatedFieldName }) => associatedFieldName === Facets.PRICE,
    );
    const element = data?.elements?.[0] as FactFinderFacetElementPrice;

    return !data || !element
      ? null
      : {
          min: Math.floor(element.absoluteMinValue),
          max: Math.ceil(element.absoluteMaxValue),
          currency: data.unit,
        };
  }, [facets]);
  const initPrice = getInitPrices(filters, priceInfo?.min, priceInfo?.max);

  const onChange = (value: Values) => {
    addSingleFilter({
      type: Facets.PRICE,
      value,
      displayValue: `${value[0]} - ${value[1]} ${priceInfo?.currency}`, // 1 - 100 $
    });
  };

  return !priceInfo ? null : (
    <FilterItem>
      <RangeSliderWithCurrency
        min={priceInfo.min}
        max={priceInfo.max}
        currency={priceInfo.currency}
        onChange={onChange}
        selectedRange={initPrice}
      />
    </FilterItem>
  );
};
